const mostUsedEmailDomains = new Set([
  'gmail.com',
  'hotmail.com',
  'yahoo.com',
  'aol.com',
  'marketplace.amazon.com',
  'comcast.net',
  'icloud.com',
  'outlook.com',
  'absolunet.com',
  'msn.com',
  'me.com',
  'verkopen.bol.com',
  'sbcglobal.net',
  'live.com',
  'live.nl',
  'mac.com',
  'att.net',
  'verizon.net',
  'shaw.ca',
  'yahoo.ca',
  'telenet.be',
  'cox.net',
  'bellsouth.net',
  'members.ebay.com',
  'rogers.com',
  'videotron.ca',
  'example.com',
  'ymail.com',
  'telus.net',
  'live.ca',
  'hotmail.ca',
  'hotmail.co.uk',
  'ziggo.nl',
  'sympatico.ca',
  'charter.net',
  'hotmail.nl',
  'bigpond.com',
  'hotmail.fr',
  'email.com',
  'home.nl',
  'earthlink.net',
  'marketplace.amazon.ca',
  'optonline.net',
  'yahoo.co.uk',
  'bgsu.edu',
  'kpnmail.nl',
  'skynet.be',
  'relay.walmart.com',
  'rocketmail.com',
  'btinternet.com',
]);

export default mostUsedEmailDomains;
